exports.f=require("./_wks");

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIl93a3MtZXh0LmpzIl0sIm5hbWVzIjpbImV4cG9ydHMiLCJmIiwicmVxdWlyZSJdLCJtYXBwaW5ncyI6IkFBQUFBLFFBQVFDLEVBQUlDLFFBQVEiLCJmaWxlIjoiL25vZGVfbW9kdWxlcy9jb3JlLWpzL21vZHVsZXMvX3drcy1leHQuanMifQ==